export const PAGE_HEIGHT = 810 + 60; // 60 for banner
export const PAGE_HEIGHT_MOBILE = 810;
export const TIME_TO_DELETE_CARD = 400;
export const CARD_WIDTH = 342;
export const CARD_HEIGHT = 613;
export const CARDS_STACK_HEIGHT = 629;
export const THRESHOLD_CARD_LINKS_ENABLED = 10;
export const THRESHOLD = 80;
export const THRESHOLD_ACTION = 100;
export const MOBILE_HEADER_HEIGHT = 42;

export const LOCAL_STORAGE_TUTORIAL_KEY = 'dream-machine-tutorial-seen';
